var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddtoscreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    className: "text-ui-primary inline-block -mt-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5385_203346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1107 5.09268L6.99957 2.18359M6.99957 2.18359L3.88845 5.09268M6.99957 2.18359V11.6381M2.52734 8.00178H0.777344V13.82C0.777344 14.2057 0.941232 14.5757 1.23296 14.8485C1.52468 15.1213 1.92034 15.2745 2.3329 15.2745H11.6662C12.0788 15.2745 12.4745 15.1213 12.7662 14.8485C13.0579 14.5757 13.2218 14.2057 13.2218 13.82V8.00178H11.6662",
    stroke: "#00A4FA",
    strokeWidth: 2.18182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5385_203346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtoscreen);
export default __webpack_public_path__ + "static/media/addtoscreen.b8ab471944849b29e31fae8652b7c7e9.svg";
export { ForwardRef as ReactComponent };